// src/components/Steps/DivisionStep.js
import React from 'react';
import Division from '../Division';

export default function DivisionStep({
  divisionSelection,
  setDivisionSelection,
  onNext,
  competition,
  setStep,
  setDisplaySuccess
}) {
  const handleNext = () => onNext();

  return (
    <Division
      divisionSelection={divisionSelection}
      competition={competition}
      setDivisionSelection={setDivisionSelection}
      setStep={setStep}
      setDisplaySuccess={setDisplaySuccess}
      onNext={handleNext}
    />
  );
}